"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbovePromotion_1 = require("../../model/constraint/AbovePromotion");

var AverageMargin_1 = require("../../model/constraint/AverageMargin");

var ConstraintTypeEnum_1 = require("../../model/constraint/ConstraintTypeEnum");

var ListingPriceProtection_1 = require("../../model/constraint/ListingPriceProtection");

var PromoProtection_1 = require("../../model/constraint/PromoProtection");

var RepricingFrequency_1 = require("../../model/constraint/RepricingFrequency");
/**
 * Builds {@link SimpleConstraint simple constraint}.
 *
 * @author RV
 */


var SimpleConstraintBuilder =
/*#__PURE__*/
function () {
  /**
   * @param type the type of constraint
   * @param value the value of simple constraint
   */
  function SimpleConstraintBuilder(type, value) {
    _classCallCheck(this, SimpleConstraintBuilder);

    this.type = type;
    this.value = value;
  }
  /**
   * @returns builded {@link SimpleConstraint simple constraint}.
   */


  _createClass(SimpleConstraintBuilder, [{
    key: "build",
    value: function build() {
      switch (this.type) {
        case ConstraintTypeEnum_1.ConstraintTypeEnum.AverageMargin:
          {
            return new AverageMargin_1.AverageMargin(AverageMargin_1.AverageMargin.schema.value.valueOf(this.value));
          }

        case ConstraintTypeEnum_1.ConstraintTypeEnum.RepricingFrequency:
          {
            return new RepricingFrequency_1.RepricingFrequency(RepricingFrequency_1.RepricingFrequency.schema.value.valueOf(this.value));
          }

        case ConstraintTypeEnum_1.ConstraintTypeEnum.ListingPriceProtection:
          {
            return new ListingPriceProtection_1.ListingPriceProtection(ListingPriceProtection_1.ListingPriceProtection.schema.value.valueOf(this.value));
          }

        case ConstraintTypeEnum_1.ConstraintTypeEnum.AbovePromotion:
          {
            return new AbovePromotion_1.AbovePromotion(AbovePromotion_1.AbovePromotion.schema.value.valueOf(this.value));
          }

        case ConstraintTypeEnum_1.ConstraintTypeEnum.PromoProtection:
          {
            return new PromoProtection_1.PromoProtection(PromoProtection_1.PromoProtection.schema.value.valueOf(this.value));
          }

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(this.type));
          }
      }
    }
  }]);

  return SimpleConstraintBuilder;
}();

exports.SimpleConstraintBuilder = SimpleConstraintBuilder;